import PropTypes from "prop-types";
import typedAction from "data/util/typedAction";

const implKeyShape = {
    implementationKey: PropTypes.string.isRequired,
};

const NavigationActions = {
    FOCUS_FIELD: "navigation/focus-field",

    SELECT_RECORD: "navigation/select-record",
    SELECT_IMPLEMENTATION: typedAction("navigation/select-implementation", implKeyShape),
    TOGGLE_IMPLEMENTATION: typedAction("navigation/toggle-implementation", implKeyShape),
    SELECT_ALL_IMPLEMENTATIONS: "navigation/select-all-implementations",
};

export default NavigationActions;



// WEBPACK FOOTER //
// ./app/data/NavigationActions.js